<template>
  <!-- do not display for now-->
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="ml-3" color="white" dark text v-bind="attrs" v-on="on">
        {{ currentDivision }}
        <v-icon>
          mdi-menu-down
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        @click="selectDivision(item)"
        v-for="(item, index) in userDivisions"
        :key="index"
      >
        <v-list-item-title>{{ item }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const configModule = createNamespacedHelpers('config')
const authModule = createNamespacedHelpers('authentication')
export default {
  name: 'DivisionSelector',
  computed: {
    ...configModule.mapState(['divisions', 'currentDivision']),
    ...authModule.mapGetters(['user']),
    userDivisions() {
      if (this.user.division === '3DIV') {
        return this.divisions
      } else {
        return [this.user.division]
      }
    }
  },
  methods: {
    ...configModule.mapActions(['changeDivision']),

    selectDivision(item) {
      this.changeDivision(item)
    }
  }
}
</script>

<style></style>
